module.exports = __webpack_public_path__ + "img/strategy2.2b9b1c94.jpg";